import Button from "../../Shared/Button/Button";

const selectedClass = "!py-1.5 !px-[18px] !text-lg !font-medium";
const notSelectedClass =
  "rounded !border-inputBorder !py-1.5 !px-[18px] !text-lg !font-medium !text-black !text-opacity-50";

const InputOption = ({ title, subCategory, onClick }) => {
  return (
    <div className="mt-8">
      <p className="mb-4 font-pop text-[22px] font-semibold text-darkGreen">
        {title}
      </p>
      <div className="flex w-1/2 gap-7">
        <Button
          text="Yes"
          onClick={() => onClick(true)}
          variant={subCategory ? "primary" : "outline"}
          className={subCategory ? selectedClass : notSelectedClass}
        />
        <Button
          onClick={() => onClick(false)}
          text="No"
          variant={!subCategory ? "primary" : "outline"}
          className={subCategory ? notSelectedClass : selectedClass}
        />
      </div>
    </div>
  );
};

export default InputOption;
